import {
  FaUser,
  FaPhoneAlt,
  FaEnvelope,
  FaPen,
} from "react-icons/fa";

import "./ContactSection.css";

export default function ContactSection() {
  return (
    <section className="contact-section">

      <div className="container contact-grid">

        {/* LEFT */}

        <div className="contact-info">

          <h2>Make It Personal. Lets Talk!</h2>

          <p>
            The shift towards targeted, individualized communication
            represents a new frontier in customer engagement.

            Let's talk to explore ideas where every customer feels
            valued and inspired.
          </p>

        </div>

        {/* RIGHT */}

        <form className="contact-form">

          <div className="row">

            <div className="input-group">
              <FaUser />
              <input placeholder="NAME *" />
            </div>

            <div className="input-group">
              <FaUser />
              <input placeholder="TITLE *" />
            </div>

          </div>

          <div className="row">

            <div className="input-group">
              <FaEnvelope />
              <input placeholder="EMAIL *" />
            </div>

            <div className="input-group">
              <FaPhoneAlt />
              <input placeholder="PHONE *" />
            </div>

          </div>

          <div className="input-group textarea-group">
            <FaPen />

            <textarea
              rows="8"
              placeholder="YOUR MESSAGE *"
            />
          </div>

          {/* Placeholder for reCAPTCHA */}

          <div className="captcha">
            I'm not a robot
          </div>

          <button className="submit-btn">
            Submit
          </button>

        </form>

      </div>

    </section>
  );
}